import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import Login from "./pages/Login";
import Transactions from "./pages/Transactions";
import ProjectDetails from "./pages/ProjectDetails";
import HtmlDisplay from "./pages/HtmlDisplay";
import AppendData from "./pages/AppendData";
import Reports from "./pages/Reports";
import ClientLogin from "./pages/ClientLogin";
import ClientLogs from "./pages/ClientLogs";

function ProtectedRoute({ children }) {
  const isAuthenticated = useIsAuthenticated();
  const isClientUser = !!localStorage.getItem('clientToken');
  return (isAuthenticated || isClientUser) ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/projects" element={<ProtectedRoute><ProjectDetails /></ProtectedRoute>} />
        <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />
        <Route path="/html-display" element={<ProtectedRoute><HtmlDisplay /></ProtectedRoute>} />
        <Route path="/append-data" element={<ProtectedRoute><AppendData /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/client-login" element={<ClientLogin />} />
        <Route path="/client-logs" element={<ClientLogs />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
